// extracted by mini-css-extract-plugin
export default {"body":"gTzpLuvpZdO_725LnAti","input":"dnaTNXvBS1d3dhCvQtvQ"};